export default [
  {
    name: 'facebook',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7, 10]
  },
  {
    name: 'youtube',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7],
    regex: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/i,
    url: 'https://www.youtube.com/embed/$5',
    params: { 'picture-in-picture': 1, accelerometer: 1, gyroscope: 1 }
  },
  {
    name: 'vimeo',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4],
    regex: /^.*vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i,
    url: 'https://player.vimeo.com/video/$1',
    params: { title: 0, byline: 0, portrait: 0 }
  },
  {
    name: 'dailymotion',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4],
    regex: /^.*(?:\/video|dai.ly)\/([A-Za-z0-9]+)([^#&?]*).*/i,
    url: 'https://www.dailymotion.com/embed/video/$1',
    params: { autoplay: 0 }
  },
  {
    name: 'google_maps',
    purpose: 'marketing',
    purposes: [1, 3, 10]
  },
  {
    name: 'google_fonts',
    purpose: 'functional',
    purposes: [1, 10]
  },
  {
    name: 'mixpanel',
    purpose:'analytics',
    purposes: [1, 6]
  },
  {
    name: 'sentry',
    purpose:'analytics',
    purposes: [1, 7, 10]
  }
]